module.exports = __webpack_public_path__ + "img/podium_5089.db77dbb3.jpg";